(() => {
  const feeId = '71550617813245';
  const designId = '71550617846013';
  const root = () => window.Shopify?.routes?.root || '/';
  const pending = new WeakSet();
  const price = amount => new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {style:'currency', currency:'INR', maximumFractionDigits:0}).format(amount);
  function configure(form) {
    const service = form.querySelector('[data-wf-service]');
    if (!service) return;
    const active = service.value !== 'none';
    const fields = form.querySelector('[data-wf-service-fields]');
    fields.hidden = !active;
    fields.querySelectorAll('input,textarea').forEach(field => {field.disabled = !active;});
    const file = form.querySelector('[data-wf-artwork]');
    file.required = service.value === 'art';
    const brief = form.querySelector('[data-wf-brief]');
    brief.required = service.value === 'design';
    const quantity = Math.max(1, Number(form.querySelector('[name="quantity"]')?.value) || 1);
    form.querySelector('[data-wf-fee-total]').textContent = active ? `Personalization: ${price(250 * quantity)}${service.value === 'design' ? ` + ${price(500)} design fee` : ''}` : '';
    const accelerated = form.querySelector('shopify-accelerated-checkout, .shopify-payment-button');
    if (accelerated) accelerated.hidden = active;
  }
  document.addEventListener('change', e => {
    const form = e.target.closest('form');
    if (form?.querySelector('[data-wf-service]')) configure(form);
  });
  document.addEventListener('input', e => {
    if (e.target.matches('[name="quantity"]')) configure(e.target.closest('form'));
  });
  document.addEventListener('submit', async e => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    const service = form.querySelector('[data-wf-service]');
    if (!service || service.value === 'none') return;
    e.preventDefault(); e.stopImmediatePropagation();
    if (pending.has(form)) return;
    configure(form);
    if (!form.reportValidity()) return;
    const file = form.querySelector('[data-wf-artwork]');
    if (file.files.length && file.files[0].size > 10 * 1024 * 1024) {
      file.setCustomValidity('Please select a file smaller than 10 MB.'); file.reportValidity(); return;
    }
    file.setCustomValidity('');
    const source = new FormData(form);
    const data = new FormData();
    const group = crypto.randomUUID();
    const quantity = Math.max(1, Number(source.get('quantity')) || 1);
    data.set('items[0][id]', source.get('id'));
    data.set('items[0][quantity]', String(quantity));
    if (source.get('selling_plan')) data.set('items[0][selling_plan]', source.get('selling_plan'));
    for (const [key,value] of source) {
      const property = key.match(/^properties\[(.*)\]$/);
      if (property && (!(value instanceof File) || value.size)) data.append(`items[0][properties][${property[1]}]`,value);
    }
    data.set('items[0][properties][_wf_group]', group);
    data.set('items[0][properties][_wf_role]', 'product');
    data.set('items[0][properties][_wf_design]', service.value === 'design' ? 'yes' : 'no');
    data.set('items[0][properties][Personalization]', service.value === 'design' ? 'Team-designed sticker' : 'Supplied artwork sticker');
    data.set('items[1][id]', feeId);data.set('items[1][quantity]', String(quantity));
    data.set('items[1][properties][_wf_group]', group);data.set('items[1][properties][_wf_role]', 'personalization');
    if (service.value === 'design') {
      data.set('items[2][id]', designId);data.set('items[2][quantity]', '1');
      data.set('items[2][properties][_wf_group]', group);data.set('items[2][properties][_wf_role]', 'design');
    }
    const error = form.querySelector('[data-wf-custom-error]');error.hidden = true;
    pending.add(form);const buttons = [...form.querySelectorAll('button[type="submit"]')];buttons.forEach(b => b.disabled = true);
    try {
      const response = await fetch(root()+'cart/add.js',{method:'POST',body:data});
      if (!response.ok) throw new Error('Cart add failed');
      await response.json();location.assign(root()+'cart');
    } catch (failure) {error.hidden=false;}
    finally {pending.delete(form);buttons.forEach(b => b.disabled=false);}
  },true);
  document.addEventListener('change',e => {if(e.target.matches('[data-wf-artwork]')) e.target.setCustomValidity('');});
  function reconciliation(cart) {
    const parents = new Map();const updates = {};const adds = [];
    for (const item of cart.items) if (item.properties?._wf_role === 'product') parents.set(item.properties._wf_group,item);
    for (const item of cart.items) {
      const role = item.properties?._wf_role;
      if (role !== 'personalization' && role !== 'design') continue;
      const parent = parents.get(item.properties._wf_group);
      const target = parent ? (role === 'personalization' ? parent.quantity : parent.properties._wf_design === 'yes' ? 1 : 0) : 0;
      if (item.quantity !== target) updates[item.key] = target;
    }
    for (const [group,parent] of parents) {
      for (const [role,id,quantity] of [['personalization',feeId,parent.quantity],['design',designId,1]]) {
        if (role === 'design' && parent.properties._wf_design !== 'yes') continue;
        const existing = cart.items.find(i=>i.properties?._wf_group===group && i.properties._wf_role===role);
        if (!existing) adds.push({id,quantity,properties:{_wf_group:group,_wf_role:role}});
      }
    }
    return {updates,adds};
  }
  let syncPromise;
  async function sync() {
    if (syncPromise) return syncPromise;
    syncPromise = (async()=>{
      const response = await fetch(root()+'cart.js');if(!response.ok)throw new Error('Cart unavailable');
      const {updates,adds} = reconciliation(await response.json());
      for(const [path,payload] of [['cart/update.js',{updates}],['cart/add.js',{items:adds}]]) {
        if(path.includes('update') ? !Object.keys(updates).length : !adds.length)continue;
        const result = await fetch(root()+path,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(payload)});
        if(!result.ok)throw new Error('Personalization unavailable');
      }
      return Object.keys(updates).length>0 || adds.length>0;
    })();
    try{return await syncPromise;}finally{syncPromise=undefined;}
  }
  document.addEventListener('submit',async e=>{
    if(!e.target.matches('form[action*="/cart"]') || !e.submitter?.matches('[name="checkout"]'))return;
    e.preventDefault();e.stopImmediatePropagation();
    try{await sync();location.assign(root()+'checkout');}catch(error){alert('Please refresh your cart or contact White Flowerr before checking out.');}
  },true);
  document.addEventListener('click',async e=>{
    const link=e.target.closest('a[href*="/checkout"]');if(!link)return;
    e.preventDefault();e.stopImmediatePropagation();
    try{await sync();location.assign(link.href);}catch(error){alert('Please refresh your cart or contact White Flowerr before checking out.');}
  },true);
  function init(){document.querySelectorAll('form').forEach(configure);}
  init();document.addEventListener('shopify:section:load',init);
  window.wfPersonalizationReconciliation = reconciliation;
})();
